import {useEffect, useRef, useState} from 'react'
import {message, Switch} from "antd";
import {
  SActionBtn,
  SDrawerOrModal,
  SGeneralForms,
  SLowcodeList, SMessage,
  STableActions,
} from 'shj-components'
import {isEmpty} from "lodash-es";

import {config} from './config.tsx'
import {apiData2Table, trimStr} from "@/utils/data.ts";
import {channelBrandAdd, channelBrandUpdateById, delChannelBrand, getChannelBrandPage} from "@/services/getUsers.ts";

export default function ClueBrand() {
  const listRef = useRef()
  const formRef = useRef()
  const [open, setOpen] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [record, setRecord] = useState({})

  const onFormRef = () => {
    const {onFormRef} = formRef.current || {};
    return onFormRef?.()
  }

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      getChannelBrandPage({params: {pageId: current, pageSize}, data: {...query}})
          .then(res => resolve(apiData2Table(res)))
          .catch(reject)
    })
  }

  const onAdd = () => onEdit()
  const onEdit = (record = {}) => {
    setOpen(true)
    setRecord(record)
  }

  useEffect(() => {
    onFormRef()?.resetFields()
    if(open && !isEmpty(record)) {
      onFormRef()?.setFieldsValue({...record})
    } else {
      setRecord({})
    }
  }, [open]);

  //  表格事件: 删除
  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return delChannelBrand(id).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onChangeStatus = (enabled: boolean, record) => {
    SMessage.confirm({
      title: '修改状态',
      content: `是否确认${enabled ? '启用' : '禁用'}该数据`,
      onOk: () => {
       return channelBrandUpdateById( {...record, enabled}).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onSubmit = () => {
    onFormRef().validateFields().then(values => {
      setBtnLoading(true)
      const values_ = {
        ...values,
      }
      const apiUrl = values.id ? channelBrandUpdateById : channelBrandAdd
      apiUrl(values_).then((res: any) => {
        message.success(res.message || '操作成功');
        listRef.current?.reload()
        setOpen(false)
      }).finally(() => {
        setBtnLoading(false)
      })
    })
  }
  const extensions = {
    request: {fetchList},
    events: {onAdd},
    status: {
      selectedDisabled: ({selectedRowKeys}: any) => !selectedRowKeys.length,
      radioDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return <Switch checked={v} onClick={(checked) => onChangeStatus(checked, record)}/>
      },
      actionRender(_, record: Record<string, any>) {
        return (
            <STableActions>
              <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
              <SActionBtn danger onClick={() => onDel(record.id)}>删除</SActionBtn>
            </STableActions>
        )
      },
    },
  }
  return (
      <div>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
        <SDrawerOrModal
            title={(record.id ? '编辑' : '新增')}
            mode="modal"
            open={open}
            loading={btnLoading}
            onCancel={() => setOpen(false)}
            onOk={onSubmit}
            width={500}
        >
              <SGeneralForms
                  ref={formRef}
                  layout={'vertical'}
                  configs={[
                    {
                      formItem: [
                        {label: 'id', name: 'id', hidden: true},
                        {
                          label: '名称',
                          name: 'brandName',
                          required: true,
                          rules: [{required: true, message: '名称不能为空'}],
                          spanCol: 24,
                          comConfig: {
                            showCount: true, maxLength: 20,
                            onChange: (e) => onFormRef()?.setFieldValue('brandName', trimStr(e.target.value))
                          }
                        },
                        {
                          label: '备注',
                          name: 'description',
                          type: 'textarea',
                          spanCol: 24,
                          comConfig: {
                            showCount: true, maxLength: 200,
                          }
                        },
                      ],
                    },
                  ]}
              />
        </SDrawerOrModal>
      </div>
  )
}
